export default __webpack_public_path__ + "static/media/subflow-node.f3203e94.svg";